import React, {Component} from 'react'
import PropTypes from 'prop-types'

class PreviewImage extends Component {
    render() {
        const {url} = this.props
        const style = {
            backgroundImage: `url('${url}')`,
        }

        return (
            <div className="PreviewImage">
                <div className="ContainerImage">
                    <div className="Background" style={style}/>
                    <img src={url} alt="preview"/>
                </div>
            </div>
        )
    }
}

PreviewImage.propTypes = {
    url: PropTypes.string.isRequired,
}

export default PreviewImage
